<script>
import { playerState } from "@app/store/playerStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { toMediaUrl } from "@app/lib/audio/stems.js";

/* Seconds a stem may drift from the video clock before it is re-seeked */
const DRIFT_TOLERANCE = 0.15;

let backgroundPlayer = $state();
let foregroundPlayer = $state();

let backgroundSrc = $derived(toMediaUrl(projectState.media?.stems?.background?.localPath));
let foregroundSrc = $derived(toMediaUrl(projectState.media?.stems?.foreground?.localPath));

function syncStem(audio, src, time, playing, speed) {
    if (!audio || !src) return;

    try {
        const rate = Number(speed) || 1;
        if (audio.playbackRate !== rate) {
            audio.playbackRate = rate;
        }

        if (Math.abs(audio.currentTime - time) > DRIFT_TOLERANCE) {
            audio.currentTime = Math.max(0, time);
        }

        if (playing && audio.paused) {
            audio.play().catch((err) => console.log(err.message));
        } else if (!playing && !audio.paused) {
            audio.pause();
        }
    } catch (err) {
        console.log(err.message);
    }
}

$effect(() => {
    const time = playerState.time;
    const playing = playerState.playing;
    const speed = playerState.speed;

    syncStem(backgroundPlayer, backgroundSrc, time, playing, speed);
    syncStem(foregroundPlayer, foregroundSrc, time, playing, speed);
});
</script>

{#if backgroundSrc}
    <audio bind:this={backgroundPlayer} bind:volume={playerState.backgroundVolume} id="backgroundStemPlayer" class="d-none" preload="auto" src={backgroundSrc}></audio>
{/if}
{#if foregroundSrc}
    <audio bind:this={foregroundPlayer} bind:volume={playerState.foregroundVolume} id="foregroundStemPlayer" class="d-none" preload="auto" src={foregroundSrc}></audio>
{/if}
